import IconButton from '@components/v2/ui/IconButton/IconButton';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { ChevronRight } from 'lucide-react';
import { MouseEvent } from 'react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import { TargetRowToggle } from './targetRowLabel.types';

interface TargetRowLabelProps {
  label: string;
  toggle?: TargetRowToggle;
  toggleTestId?: string;
}

const TargetRowLabel = ({ label, toggle, toggleTestId }: TargetRowLabelProps) => {
  const { translate } = useTranslation();

  const handleToggleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    toggle?.onToggle();
  };

  return (
    <Stack direction="row" sx={{ alignItems: 'center', gap: 1, minWidth: 0 }}>
      {toggle && (
        <IconButton
          size="small"
          icon={ChevronRight}
          ariaLabel={translate(
            toggle.isExpanded ? LangEnum.GLOBAL_COLLAPSE : LangEnum.GLOBAL_EXPAND,
          )}
          ariaExpanded={toggle.isExpanded}
          tabIndex={toggle.isEnabled ? undefined : -1}
          testId={toggleTestId}
          sx={(theme) => ({
            flexShrink: 0,
            visibility: toggle.isEnabled ? 'visible' : 'hidden',
            '& svg': {
              transform: toggle.isExpanded ? 'rotate(90deg)' : 'none',
              transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shortest,
              }),
              '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
            },
          })}
          onClick={handleToggleClick}
        />
      )}
      <Typography noWrap variant="inherit" title={label}>
        {label}
      </Typography>
    </Stack>
  );
};

export default TargetRowLabel;
